import React from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import MuiTablePagination from "@mui/material/TablePagination";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";
import IconButton from "@src/sharedComponents/IconButton/IconButton";

import styles from "./TablePagination.module.css";

export interface TablePaginationProps {
  className?: string;
  pageSize: number;
  currentPage: number;
  totalCount: number;
  onPageChange: (page: number) => void;
  isPrevButtonDisabled: boolean;
  isNextButtonDisabled: boolean;
}

export const TablePagination: React.FC<TablePaginationProps> = ({
  className,
  pageSize,
  currentPage,
  totalCount,
  onPageChange,
  isPrevButtonDisabled,
  isNextButtonDisabled,
}) => {
  return (
    <MuiTablePagination
      component="div"
      classes={{
        root: toClassName(styles.root, className),
        toolbar: styles.toolbar,
        displayedRows: styles.displayedRows,
      }}
      rowsPerPage={pageSize}
      rowsPerPageOptions={[pageSize]}
      page={currentPage}
      count={totalCount}
      onPageChange={(_, page) => onPageChange(page)}
      ActionsComponent={(actionProps) => (
        <div className={styles.actions}>
          <IconButton
            iconClassName={styles.actionIcon}
            onClick={() => onPageChange(actionProps.page - 1)}
            disabled={isPrevButtonDisabled}
            disableRipple
            disableFocusRipple
            IconComponent={ArrowBackIcon}
          />
          <IconButton
            iconClassName={styles.actionIcon}
            onClick={() => onPageChange(actionProps.page + 1)}
            disabled={isNextButtonDisabled}
            disableRipple
            disableFocusRipple
            IconComponent={ArrowForwardIcon}
          />
        </div>
      )}
    />
  );
};
